import React, {Component} from "react";
import MFA from "./MFAView";
import {LoginService} from "../../service/login/LoginService";
import {CHANGE_PASSWORD_ROUTE, MFA_MANUAL_ROUTE} from "../../utils/constants/RoutesConstants";


export default class MFAContainer extends Component {
    constructor(props) {
        super(props);

        this.loginService = new LoginService();

        this.state = {
            username: localStorage.getItem("username"),
            qrUrlAuth: localStorage.getItem("qrUrlAuth"),
            token: ""
        }

        this.updateToken = this.updateToken.bind(this);
        this.singInMfa = this.singInMfa.bind(this);
        this.redirectToManual = this.redirectToManual.bind(this);
    }

    updateToken(event) {
        const {value} = event.target;
        this.setState({token: value})
    }

    singInMfa(event) {
        event.preventDefault();
        this.loginService.singUpMFA(this.state.username, this.state.token)
            .then(data => {
                if (data.screen === "" || data.screen === "NOTIFICATION") {
                    localStorage.setItem("username", data.username);
                    localStorage.setItem("institution", data.shortName);
                    this.setToken(data.accessToken, data.refreshToken);
                    localStorage.setItem("menu", data.menu);
                    localStorage.setItem("institutionId", data.institutionId);
                    localStorage.setItem("notificationMessage", data.screen === "NOTIFICATION" ? "notificationMessage" : "");
                    this.props.history.push("/app");
                    window.location.reload();
                } else if (data.screen === "ERROR") {
                    alert(data.message);
                    this.setState({
                        token: '',
                    });
                    if(data.message.includes("Tu cuenta ha sido bloqueada")) {
                        this.cancelMfa();
                    }
                } else if (data.screen === "EXPIRED") {
                    alert(data.message);
                    localStorage.setItem("username", data.username);
                    this.props.history.push({
                        pathname: CHANGE_PASSWORD_ROUTE,
                    });
                } else {
                    this.setState({
                        username: '',
                        password: '',
                    });
                }
                });
    }

    setToken(accessToken, refreshToken) {
        localStorage.setItem("accessToken", accessToken);
        localStorage.setItem("refreshToken", refreshToken);
    }
    redirectToManual(e){
        e.preventDefault();
        e.stopPropagation();
        const fileUrl = window.location.origin +'/v2'+ MFA_MANUAL_ROUTE;
        window.open(fileUrl, '_blank', 'noopener,noreferrer');
    }

    cancelMfa(){
        localStorage.clear();
        window.location.reload();
    }

    render() {
        return <MFA
            token={this.state.token}
            qrUrl={this.state.qrUrlAuth}
            updateToken={this.updateToken}
            singInMfa={this.singInMfa}
            redirectToManual={this.redirectToManual}
            cancelMfa={this.cancelMfa}
        />
    }
}